import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { ElementModule } from './element.module'
import { AppComponent } from './app.component'
import { ChatService } from './chat/chat.service'
import { appRoutes } from './app.routes'
import { ChatErrorInterceptor } from './chat/chat-error.interceptor'
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatIconModule } from '@angular/material/icon'
import { IconsModule } from './core/icons/icons.module'
import { ImageViewerComponent } from './chat/image-viewer/image-viewer.component'

@NgModule({
  imports: [
    BrowserModule, 
    BrowserAnimationsModule, 
    ElementModule,
    MatIconModule,
    IconsModule, 
    RouterModule.forRoot(appRoutes)
  ],
  providers: [
    ChatService,
    { provide: HTTP_INTERCEPTORS, useClass: ChatErrorInterceptor, multi: true }
  ],
  declarations: [
    AppComponent, 
    ImageViewerComponent
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
